import { Controller } from '@hotwired/stimulus';

// Sends a postMessage to the parent window on connect.
// Used inside iframes to notify the parent of a result.
//
// Usage:
//   <div data-controller="iframe-callback"
//        data-iframe-callback-type-value="lemonway-payment-callback"
//        data-iframe-callback-status-value="success">
export default class IframeCallbackController extends Controller {
  static values = {
    type: String,
    status: String,
  };

  connect() {
    window.parent.postMessage(
      { type: this.typeValue, status: this.statusValue },
      window.location.origin,
    );
  }
}
